import React, { useEffect, useState } from 'react'
import { InfoAlert } from '../../CommonUtils/SweetAlerts';
import { viewImage } from '../../CommonUtils/viewImage';
import CommonReactTable from '../../CommonUtils/CommonReactTable';
import * as bie from "react-bootstrap";
import { FaFilePdf } from 'react-icons/fa';
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosGet } from '../../CommonUtils/CommonAxios';

export default function AfflBbaBcaCoursesReport() {
    const [showName, setShowName] = useState("");
    const [ubname, setUbname] = useState("");
    const [showDrillCount, setShowDrillCount] = useState();
    const [bbaBcaData, setBbaBcaData] = useState([]);
    const Ubcode = sessionStorage.getItem('ub_code');
    function GetbbabcaReportLevel1() {
        let url = config.url.API_URL + "bbabcacourcesreportho/" + Ubcode;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setBbaBcaData(res?.data?.data);
                console.log("fffffff", res?.data?.data?.length);

                setShowDrillCount(0)
            }
            else {
                setBbaBcaData([])
            }
        })
    }


    const [bba_bcaLevelTwo, setBba_bcaLevelTwo] = useState([]);
    function GetbbabcaReport(ubcode, level) {
        if (!ubcode || !level) {
            return
        }
        else {

            console.log("ubcode,level>>>>>>>>>>>>", ubcode, level)
            let url = config.url.API_URL + "bbabcacourcesreporthodrill/" + ubcode + "/" + level;
            CommonAxiosGet(url).then((res) => {
                if (res?.data?.scode === '01') {
                    setBba_bcaLevelTwo(res?.data?.data);
                    setShowDrillCount(1);
                }
                else {
                    setBba_bcaLevelTwo([]);
                }
            })

        }
    }

    const BBA_BCAColumns = [
        {
            Header: "Sl.No", accessor: (row, index) => index + 1,
            Footer: 'Total'
        },


        {
            Header: "University Name", accessor: "ub_name",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.ub_name}</div>
            ),
        },
        {
            Header: "Total Applied Colleges", accessor: "total",
            Cell: ({ row }) => (
                <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
                    onClick={() => {
                        if (row?.original?.total === 0) {
                            InfoAlert("No Data Found")
                        }
                        else {
                            GetbbabcaReport(row?.original?.ub_code, 1);
                            setShowName("Total Applied Colleges");
                            setUbname(row?.values?.ub_name);
                        }
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            GetbbabcaReport(row?.original?.ub_code, 1);
                            setShowName("Total Applied Colleges");
                            setUbname(row?.values?.ub_name);

                        }
                    }}  >{row?.values?.total}</div>
            ),
            Footer: "total"
        },
        {
            Header: "CDC Confirmed", accessor: "cdc_confirm",
            Cell: ({ row }) => (
                <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
                    onClick={() => {
                        if (row?.original?.cdc_confirm === 0) {
                            InfoAlert("No Data Found")
                        }
                        else {
                            GetbbabcaReport(row?.original?.ub_code, 2);
                            setShowName("CDC Confirmed")
                            setUbname(row?.values?.ub_name);

                        }
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            GetbbabcaReport(row?.original?.ub_code, 2);
                            setShowName("CDC Confirmed")
                            setUbname(row?.values?.ub_name);

                        }
                    }}  >{row?.values?.cdc_confirm}</div>
            ),
            Footer: "cdc_confirm"
        },
        {
            Header: "AO Generated", accessor: "ao",
            Cell: ({ row }) => (
                <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
                    onClick={() => {
                        if (row?.original?.ao === 0) {
                            InfoAlert("No Data Found")

                        }
                        else {
                            GetbbabcaReport(row?.original?.ub_code, 3);
                            setShowName("AO Generated")
                            setUbname(row?.values?.ub_name);

                        }
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            GetbbabcaReport(row?.original?.ub_code, 3);
                            setShowName("AO Generated");
                            setUbname(row?.values?.ub_name);

                        }
                    }}  >{row?.values?.ao}</div>
            ),
            Footer: "ao"
        },
    ]
    const Level2Columns = [

        { Header: "Sl.No", accessor: (row, index) => index + 1 },
        {
            Header: "College Code", accessor: "coll_code",

        },

        {
            Header: "College Name", accessor: "inst_name",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.inst_name}</div>
            ),
        },


        {
            Header: "Acite Order", accessor: "aicte_proceeding",
            Cell: ({ row }) => (
                <button
                    type="button"
                    onClick={() => viewImage(row?.values?.aicte_proceeding)}
                    style={{ color: "red" }}
                >
                    <FaFilePdf size={23} />
                </button>
            ),
        },
        ...(showName === "AO Generated"
            ? [
                {
                    Header: "AO", accessor: "ao",
                    Cell: ({ row }) => (
                        <button
                            type="button"
                            onClick={() => viewImage(row?.values?.ao)}
                            style={{ color: "red" }}
                        >
                            <FaFilePdf size={23} />
                        </button>
                    ),
                },

            ]
            : []),
        // {
        //     Header: "Courses", accessor: "courses",
        //     Cell: ({ row }) => (
        //         <div style={{ textAlign: 'left' }}>{row?.values?.courses}</div>
        //     ),
        // },

        {
            Header: "Courses",
            accessor: "courses",
            Cell: ({ row }) => {
                const courseString = row?.values?.courses || "";
                const courseList = courseString
                    .split(')')
                    .map(course => course.trim())
                    .filter(course => course);

                return (
                    <ul style={{ textAlign: 'left', paddingLeft: '1rem', margin: 0 }}>
                        {courseList?.map((course, index) => (
                            <li key={index}>{course}</li>
                        ))}
                    </ul>
                );
            }
        }


    ]


    function isBackFunction() {
        setShowDrillCount(showDrillCount - 1)
    }

    useEffect(() => {
        GetbbabcaReportLevel1();
    }, [])
    console.log("ubname>>>>", ubname)
    return (
        <div>
            <bie.Container fluid className="px-1" >
                <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100">
                    {showDrillCount === 0 && (
                        <>

                            <div className="inner-herbpage-service-title-sub pt-0"  >
                                <h1>BBA/BCA Courses Applied Colleges Report</h1>
                            </div>
                            <bie.Row className="my-3 px-3">
                                {bbaBcaData && bbaBcaData?.length > 0 ? (

                                    <div className="table-responsive">
                                        <CommonReactTable data={bbaBcaData} columns={BBA_BCAColumns} filename="BBA/BCA Courses Applied Colleges Report"
                                            headerName={`BBA/BCA Courses Applied Colleges Report`} showFooter={"true"} />
                                    </div>
                                ) : (
                                    <b className='text-error text-center'> ***No data Found***</b>
                                )}
                            </bie.Row>

                        </>
                    )}
                    {/* ) :
                        <center className="text-danger h6"> ***No data Found***</center>
                    } */}
                    {(showDrillCount === 1) && (
                        <bie.Row className="my-3 px-3">
                            <div className="inner-herbpage-service-title-sub pt-0"  > <h1>{showName}-{ubname}</h1> </div>
                            {bbaBcaData && bbaBcaData?.length > 0 ? (

                                <div className="table-responsive">
                                    <CommonReactTable data={bba_bcaLevelTwo} columns={Level2Columns} filename={showName}
                                        headerName={"BBA/BCA Courses Applied Colleges Report"} isBack={true} isBackFunction={isBackFunction} />
                                </div>
                            ) : (
                                <b className='text-error text-center'> ***No data Found***</b>
                            )}
                        </bie.Row>
                    )}
                </bie.Container>
            </bie.Container>
        </div>


    )
}
